/* PokéVault — theme.js
   Bevat: lades, menu, zoekmodal, accordeons, galerij, aftelklok, varianten,
   vaste koopbalk, reviews, filters, sorteren, recent bekeken. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  var DESKTOP = 990;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isDesktop() { return window.innerWidth >= DESKTOP; }
  function fill(str, map) {
    return Object.keys(map || {}).reduce(function (acc, key) {
      return acc.split('[' + key + ']').join(map[key]);
    }, str || '');
  }

  /* ---------- toast ---------- */

  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }
  window.themeToast = toast;

  /* ---------- drawers ---------- */

  var openDrawer = null;
  var lastFocus = null;

  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function drawerOpen(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');
    openDrawer = el;
    var first = focusables(el)[0];
    if (first) setTimeout(function () { first.focus(); }, 30);
    $$('[aria-controls="' + el.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
  }

  function drawerClose(el) {
    el = el || openDrawer;
    if (!el) return;
    el.hidden = true;
    openDrawer = null;
    if (!$$('.drawer, .modal').some(function (d) { return !d.hidden; })) {
      document.body.classList.remove('is-locked');
    }
    $$('[aria-controls="' + el.id + '"]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.themeDrawer = { open: drawerOpen, close: drawerClose, byName: function (name) { return $('[data-drawer="' + name + '"]'); } };

  document.addEventListener('click', function (event) {
    var openMenu = event.target.closest('[data-menu-open]');
    if (openMenu) { event.preventDefault(); drawerOpen($('[data-drawer="menu"]')); return; }

    var openFacets = event.target.closest('[data-facets-open]');
    if (openFacets) { event.preventDefault(); drawerOpen($('[data-drawer="facets"]')); return; }

    var openSearch = event.target.closest('[data-search-open]');
    if (openSearch) {
      var modal = $('[data-search-modal]');
      if (modal) {
        event.preventDefault();
        drawerOpen(modal);
        var input = $('[data-predictive-input]', modal);
        if (input) setTimeout(function () { input.focus(); }, 40);
      }
      return;
    }

    var close = event.target.closest('[data-drawer-close], [data-modal-close]');
    if (close) {
      event.preventDefault();
      drawerClose(close.closest('.drawer, .modal'));
      return;
    }

    var scrollTo = event.target.closest('[data-scroll-to]');
    if (scrollTo) {
      var target = $(scrollTo.getAttribute('data-scroll-to')) || $('.section-reviews');
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var share = event.target.closest('[data-share]');
    if (share) {
      var url = share.getAttribute('data-share');
      if (navigator.share) {
        navigator.share({ url: url, title: document.title }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast(strings.linkCopied || 'OK'); }).catch(function () {});
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openDrawer) { drawerClose(); return; }
    if (event.key !== 'Tab' || !openDrawer) return;
    var list = focusables(openDrawer);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* ---------- header dropdowns ---------- */

  document.addEventListener('click', function (event) {
    $$('[data-dropdown][open]').forEach(function (drop) {
      if (!drop.contains(event.target)) drop.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') $$('[data-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* ---------- announcement rotator ---------- */

  function initRotator(root) {
    var items = $$('.announcement__msg', root);
    if (items.length < 2) return;
    var index = 0;
    setInterval(function () {
      items[index].hidden = true;
      index = (index + 1) % items.length;
      items[index].hidden = false;
    }, 4500);
  }
  $$('[data-rotator]').forEach(initRotator);

  /* ---------- accordions: closed on mobile when marked desktop-open ---------- */

  function syncAccordions() {
    $$('[data-accordion][data-open-desktop]').forEach(function (acc) {
      if (isDesktop()) {
        if (!acc.dataset.touched) acc.setAttribute('open', '');
      } else if (!acc.dataset.touched) {
        acc.removeAttribute('open');
      }
    });
  }
  $$('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('toggle', function () { acc.dataset.touched = 'true'; });
  });
  syncAccordions();

  /* ---------- gallery ---------- */

  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', root);
    var counter = $('[data-gallery-current]', root);
    if (!slides.length) return;

    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function current() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var mid = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
        var dist = Math.abs(mid - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    function sync() {
      var index = current();
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = index + 1;
    }

    var ticking;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, current() + 1)); });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(Math.min(slides.length - 1, current() + 1)); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(Math.max(0, current() - 1)); }
    });

    root.goToMedia = function (mediaId) {
      var index = slides.findIndex(function (slide) { return slide.getAttribute('data-media-id') === String(mediaId); });
      if (index > -1) goTo(index);
    };

    sync();
  }
  $$('[data-gallery]').forEach(initGallery);

  /* ---------- countdown ---------- */

  function pad(value) { return value < 10 ? '0' + value : String(value); }

  function initTimer(root) {
    var endAttr = root.getAttribute('data-end');
    var live = $('[data-sale-live]', root);
    var expired = $('[data-sale-expired]', root);
    var label = $('[data-sale-label]', root);
    var box = $('[data-countdown]', root);
    var time = root.getAttribute('data-time') || '';
    var autoLabel = root.getAttribute('data-auto-label') === 'true';
    if (!endAttr) return;

    var end = new Date(endAttr).getTime();
    if (isNaN(end)) return;

    var days = $('[data-cd-days]', root);
    var dEl = $('[data-cd-d]', root);
    var hEl = $('[data-cd-h]', root);
    var mEl = $('[data-cd-m]', root);
    var sEl = $('[data-cd-s]', root);

    function finish() {
      if (live) live.hidden = true;
      if (expired) expired.hidden = false;
      if (!expired && root.parentNode) root.hidden = true;
    }

    function sameDay(a, b) {
      return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }

    function updateLabel(now) {
      if (!label || !autoLabel) return;
      var endDate = new Date(end);
      // Bij een einde om middernacht hoort de dag ervoor: "eindigt vandaag om 00:00".
      var ref = time === '00:00' ? new Date(end - 60000) : endDate;
      var today = new Date(now);
      var tomorrow = new Date(now + 86400000);
      var text;
      if (sameDay(ref, today)) text = fill(strings.endsToday, { time: time });
      else if (sameDay(ref, tomorrow)) text = fill(strings.endsTomorrow, { time: time });
      else text = fill(strings.endsOn, { date: ref.getDate() + '-' + (ref.getMonth() + 1), time: time });
      if (text) label.textContent = text;
    }

    function tick() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) { finish(); clearInterval(interval); return; }
      updateLabel(now);
      if (!box) return;
      var totalSeconds = Math.floor(diff / 1000);
      var d = Math.floor(totalSeconds / 86400);
      var h = Math.floor((totalSeconds % 86400) / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;
      if (days) {
        days.hidden = d < 1;
        if (dEl) dEl.textContent = d;
      }
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    tick();
    var interval = setInterval(tick, 1000);
  }
  $$('[data-sale-timer]').forEach(initTimer);

  /* ---------- quantity steppers (buiten de winkelwagen) ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-step]');
    if (!btn || btn.closest('[data-line]')) return;
    var wrap = btn.closest('.qty');
    var input = $('[data-qty-input]', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var value = (parseInt(input.value, 10) || min) + step;
    if (value < min) value = min;
    if (!isNaN(max) && value > max) value = max;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant picker ---------- */

  function initVariants(section) {
    var picker = $('[data-variant-picker]', section);
    if (!picker) return;
    var dataEl = $('[data-variant-data]', picker);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (error) { return; }

    var form = $('[data-product-form]', section);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addButton = form ? $('[data-add-button]', form) : null;
    var addLabel = addButton ? $('[data-add-label]', addButton) : null;
    var stickyAdd = $('[data-sticky-add]');
    var gallery = $('[data-gallery]', section);

    function selected() {
      return $$('[data-option-value]:checked', picker).map(function (input) { return input.value; });
    }

    function match(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function updateLabels(options) {
      $$('[data-option-selected]', picker).forEach(function (el) {
        var index = parseInt(el.getAttribute('data-option-selected'), 10);
        if (options[index]) el.textContent = options[index];
      });
    }

    function updateAvailabilityHints(options) {
      $$('[data-option-value]', picker).forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-value'), 10);
        var test = options.slice();
        test[index] = input.value;
        var found = match(test);
        var label = picker.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !found || !found.available);
      });
    }

    function updatePrice(variant) {
      var priceEl = $('.buy-box__price .price', section);
      if (!priceEl) return;
      var current = $('.price__current', priceEl);
      var onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (current) current.textContent = variant.price_html;
      priceEl.classList.toggle('is-sale', onSale);

      var compare = $('.price__compare', priceEl);
      if (!compare && onSale) {
        compare = document.createElement('s');
        compare.className = 'price__compare';
        priceEl.insertBefore(compare, current || priceEl.firstChild);
      }
      if (compare) {
        compare.hidden = !onSale;
        if (onSale) compare.textContent = variant.compare_html;
      }

      var saving = $('.price__saving', priceEl);
      if (!saving && onSale) {
        saving = document.createElement('span');
        saving.className = 'price__saving';
        priceEl.appendChild(saving);
      }
      if (!saving) return;
      saving.hidden = !onSale;
      if (!onSale) return;
      var diff = variant.compare_at_price - variant.price;
      var pct = Math.round((diff / variant.compare_at_price) * 100);
      saving.textContent = fill(strings.save, { amount: formatMoney(diff) });
      if (theme.sale && theme.sale.showPct) {
        var span = document.createElement('span');
        span.className = 'price__pct';
        span.textContent = ' (-' + pct + '%)';
        saving.appendChild(span);
      }
    }

    function updateStock(variant) {
      var stock = $('.stock--pdp', section);
      if (!stock) return;
      var textEl = $('[data-stock-text]', stock);
      var config = theme.stock || {};
      stock.classList.remove('stock--low', 'stock--ok', 'stock--soldout');
      if (!variant.available) {
        stock.hidden = false;
        stock.classList.add('stock--soldout');
        if (textEl) textEl.textContent = strings.soldOut || '';
        return;
      }
      if (config.mode === 'auto' && variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny' &&
          variant.inventory_quantity > 0 && variant.inventory_quantity <= config.threshold) {
        stock.hidden = false;
        stock.classList.add('stock--low');
        if (textEl) textEl.textContent = fill(config.lowText, { count: variant.inventory_quantity });
        return;
      }
      if (config.showAvailable) {
        stock.hidden = false;
        stock.classList.add('stock--ok');
        if (textEl) textEl.textContent = config.availableText || '';
        return;
      }
      stock.hidden = true;
    }

    function updateButton(variant) {
      var label = !variant ? (strings.unavailable || '') : (variant.available ? (strings.addToCart || '') : (strings.soldOut || ''));
      if (addButton) addButton.disabled = !variant || !variant.available;
      if (addLabel) addLabel.textContent = label;
      if (stickyAdd) {
        stickyAdd.disabled = !variant || !variant.available;
        stickyAdd.textContent = label;
      }
    }

    function onChange() {
      var options = selected();
      updateLabels(options);
      updateAvailabilityHints(options);
      var variant = match(options);
      updateButton(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      updatePrice(variant);
      updateStock(variant);
      if (variant.featured_media_id && gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media_id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', onChange);
    updateAvailabilityHints(selected());
  }

  function formatMoney(cents) {
    var format = theme.moneyFormat || '€ {{amount}}';
    var value = (cents / 100);
    var amountWithComma = value.toFixed(2).replace('.', ',');
    var amountNoDecimals = Math.round(value).toString();
    var amountWithDot = value.toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amountWithDot);
  }
  window.themeMoney = formatMoney;

  $$('[data-product-section]').forEach(initVariants);

  /* ---------- sticky buy bar ---------- */

  (function stickyBar() {
    var bar = $('[data-sticky-buy]');
    var form = $('[data-product-form]');
    if (!bar || !form) return;
    var addButton = $('[data-add-button]', form);
    var stickyAdd = $('[data-sticky-add]', bar);

    if (stickyAdd && addButton) {
      stickyAdd.addEventListener('click', function () { addButton.click(); });
    }

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting || isDesktop();
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(form);
  })();

  /* ---------- reviews ---------- */

  $$('.reviews').forEach(function (section) {
    var list = $('[data-reviews-list]', section);
    var sort = $('[data-reviews-sort]', section);
    if (list && sort) {
      sort.addEventListener('change', function () {
        var items = $$('[data-review]', list);
        var mode = sort.value;
        items.sort(function (a, b) {
          var an, bn;
          if (mode === 'high' || mode === 'low') { an = +a.dataset.rating; bn = +b.dataset.rating; }
          else if (mode === 'helpful') { an = +a.dataset.helpful; bn = +b.dataset.helpful; }
          else { an = +a.dataset.date; bn = +b.dataset.date; }
          if (an === bn) return (+a.dataset.index) - (+b.dataset.index);
          return mode === 'low' ? an - bn : bn - an;
        });
        items.forEach(function (item) { list.appendChild(item); });
      });
    }
    $$('[data-helpful-btn]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-active')) return;
        btn.classList.add('is-active');
        var count = $('.review__helpful-count', btn);
        if (count) {
          var value = parseInt(count.textContent.replace(/\D/g, ''), 10) || 0;
          count.textContent = '(' + (value + 1) + ')';
        }
        toast(strings.helpfulThanks || '');
      });
    });
  });

  /* ---------- collection: sorteren en filteren ---------- */

  (function collection() {
    var section = $('[data-collection-section]');
    if (!section) return;
    var results = $('[data-collection-results]', section);
    var sortSelect = $('[data-sort-select]', section);
    var facetForm = $('[data-facet-form]', section);
    var busy = false;

    function render(url) {
      if (busy) return;
      busy = true;
      if (results) results.style.opacity = '.45';
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          var freshBar = doc.querySelector('[data-facet-bar]');
          var freshFacets = doc.querySelector('[data-facet-form]');
          var freshActive = doc.querySelector('.active-facets');
          var currentActive = $('.active-facets', section);
          if (fresh && results) results.innerHTML = fresh.innerHTML;
          var bar = $('[data-facet-bar]', section);
          if (freshBar && bar) {
            var count = freshBar.querySelector('[data-product-count]');
            var badge = freshBar.querySelector('[data-facet-active-count]');
            var currentCount = bar.querySelector('[data-product-count]');
            var currentBadge = bar.querySelector('[data-facet-active-count]');
            if (count && currentCount) currentCount.textContent = count.textContent;
            if (badge && currentBadge) {
              currentBadge.textContent = badge.textContent;
              currentBadge.hidden = badge.hidden;
            }
          }
          if (freshFacets && facetForm) {
            $$('.facet', facetForm).forEach(function (facet, index) {
              var freshFacet = freshFacets.querySelectorAll('.facet')[index];
              if (!freshFacet) return;
              var wasOpen = facet.hasAttribute('open');
              facet.innerHTML = freshFacet.innerHTML;
              if (wasOpen) facet.setAttribute('open', ''); else facet.removeAttribute('open');
            });
          }
          if (currentActive) {
            if (freshActive) currentActive.innerHTML = freshActive.innerHTML;
            else currentActive.innerHTML = '';
          } else if (freshActive) {
            results.parentNode.insertBefore(freshActive, results);
          }
          window.history.replaceState({}, '', url);
          if (results) results.style.opacity = '';
          busy = false;
        })
        .catch(function () {
          if (results) results.style.opacity = '';
          busy = false;
          window.location.href = url;
        });
    }

    function buildUrl() {
      var params = new URLSearchParams();
      if (facetForm) {
        var data = new FormData(facetForm);
        data.forEach(function (value, key) {
          if (value !== '' && key !== 'sort_by') params.append(key, value);
        });
      }
      if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
      var base = window.location.pathname;
      var query = params.toString();
      return query ? base + '?' + query : base;
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () { render(buildUrl()); });
    }
    if (facetForm) {
      facetForm.addEventListener('change', function () { render(buildUrl()); });
      facetForm.addEventListener('submit', function (event) { event.preventDefault(); render(buildUrl()); });
      var clear = $('[data-facet-clear]', facetForm);
      if (clear) {
        clear.addEventListener('click', function (event) {
          event.preventDefault();
          $$('input[type="checkbox"]', facetForm).forEach(function (input) { input.checked = false; });
          $$('input[type="number"]', facetForm).forEach(function (input) { input.value = ''; });
          render(buildUrl());
        });
      }
    }
  })();

  /* ---------- product recommendations ---------- */

  $$('[data-recommendations]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- recent bekeken ---------- */

  (function recentlyViewed() {
    var KEY = 'pokevault:recent';
    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (error) { items = []; }

    var productSection = $('[data-product-section]');
    if (productSection) {
      var handle = (productSection.getAttribute('data-url') || '').split('/products/')[1];
      if (handle) {
        handle = handle.split('?')[0];
        items = items.filter(function (item) { return item !== handle; });
        items.unshift(handle);
        items = items.slice(0, 12);
        try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (error) {}
      }
    }

    var section = $('[data-recently]');
    if (!section) return;
    var currentHandle = productSection ? (productSection.getAttribute('data-url') || '').split('/products/')[1] : null;
    var list = items.filter(function (item) { return item !== currentHandle; }).slice(0, parseInt(section.getAttribute('data-limit'), 10) || 6);
    if (!list.length) return;

    var query = list.map(function (handle) { return 'handle:' + handle; }).join(' OR ');
    var url = section.getAttribute('data-search-url') + '?q=' + encodeURIComponent(query) +
      '&type=product&options%5Bunavailable_products%5D=last&section_id=recently-viewed-results';
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.product-grid__item');
        if (!cards.length) return;
        var target = $('[data-recently-list]', section);
        if (!target) return;
        Array.prototype.forEach.call(cards, function (card) { target.appendChild(card); });
        section.hidden = false;
      })
      .catch(function () {});
  })();

  /* ---------- theme editor ---------- */

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    $$('[data-gallery]', target).forEach(initGallery);
    $$('[data-sale-timer]', target).forEach(initTimer);
    $$('[data-rotator]', target).forEach(initRotator);
    $$('[data-product-section]', target).forEach(initVariants);
    syncAccordions();
  });

  window.addEventListener('resize', syncAccordions);
})();
